const actionTypes = {
  SET_SEND_MAIL_DETAIL: 'setSendMailDetail',
  SET_PARAMS: 'setSendMailParams',
  SET_TOTAL_COUNT: 'setTotalCount',
  SET_RECEIVE_COUNT: 'setReceiveCount',
  SET_SEND_COUNT: 'setSendCount',
  SET_FOLDER_CHANGE_MODAL_STATUS: 'setFolderChangeModalStatus',
  SET_TRANSACTION_STATUS_INFO: 'setTransactionStatusInfo',
  SET_TRANSACTION_STATUS: 'setTransactionStatus',
  SET_REMIND_SEND_MAIL_DETAIL: 'setRemindMailDetail',
  SET_REMIND_PARAMS: 'setRemindMailParams',
  SET_REMIND_TOTAL_COUNT: 'setRemindMailTotalCount',
  SET_REMIND_SEND_MAIL_CHOOSED_DETAIL: 'setRemindMailChoosedDetail',
}

export default actionTypes
